import gql from 'graphql-tag';

import type { AllInstructionsData } from 'src/data/generation';
import type { UrlExtraction } from 'src/data/types';
import { executeGqlMutation, type GqlCallVariables } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp, throwIfResultHasErrors } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ClassifyLongForm(
    $customerId: ID!
    $allInstructionsData: JSON!
    $urlExtractions: [UrlExtractionInput!]
  ) {
    classifyLongForm(
      customerId: $customerId
      allInstructionsData: $allInstructionsData
      urlExtractions: $urlExtractions
    ) {
      template
    }
  }
`;

interface Variables extends GqlCallVariables {
  customerId: ID;
  allInstructionsData: AllInstructionsData;
  urlExtractions: UrlExtraction[];
}

interface Result {
  template: string;
}

export const classifyLongForm = async (variables: Variables): Promise<Result | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      ...variables,
      allInstructionsData: stringifyIfPresent(variables.allInstructionsData),
    },
    options: {
      traceAcRequests: true,
    },
  });
  throwIfResultHasErrors(result);

  return getSingleProp<Result>(result.data);
};
